import React, { useState, useEffect, useRef } from 'react'
import Modal from 'react-bootstrap/Modal'

import { PreOrderFetchAPI } from '../../../api/Paymentpost/PreOrder';
import { DeletedTempOrdersFetchAPI } from '../../../api/DeletedTemporalOrders';

import Swal from "sweetalert2";
import ErrorAlert from '../../Alerts/ErrorAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import { GiPlayerTime } from 'react-icons/gi';
import AlertSmall from '../../Alerts/AlertSmall';
import Empty from '../../utils/Empty';
import ModalDetailPreOrder from '../ModalDetailPreOrder';

import imgPreOrder from '../../PaymentPost/img/logo_sp.png'
import refund from '../../PaymentPost/img/logo_sp.png'
import { showApiError } from '../../../utils/ApiError';

import './styles.css'

function ModalDivisionequalparts({ getOrderNumber, orderNumberNow, order, setShowDivision, getAll, onPendingDelete, codeParthner, resetInputs }) {
    const [showParts, setShowParts] = useState(false);
    const countRef = useRef(0);
    const stringOrdersRferenceRef = useRef("");
    const [dataOrder, setDataOrder] = useState({})
    const [division, setDivision] = useState("");
    const [eventHandler, setEventHandler] = useState(0);
    const [stateRequest, setStateRequest] = useState(false);
    const [ordersCreated, setOrdersCreated] = useState("");
    const [dataPreviewTotals, setDataPreviewTotals] = useState({ discount: 0, subtotal: 0, tax: 0, total: 0 })
    const createdPreOrdersRef = useRef([]);
    const createdOrderCodesRef = useRef([]);

    const isPendingDeleteTimeout = (err) => {
        return err?.response?.status === 504 || err?.code === "ECONNABORTED";
    }

    const preserveKitchenStateForSplit = (items = []) => {
        return items.map((item) => {
            const wasAlreadySentToKitchen = item.kitchen_action === "send_to_kitchen" && item.isNewAdd !== true;
            return {
                ...item,
                kitchen_action: item.kitchen_action || "send_to_kitchen",
                isNewAdd: wasAlreadySentToKitchen ? false : item.isNewAdd,
                amount_to_impress: wasAlreadySentToKitchen ? 0 : Number(item.amount_to_impress ?? item.amount ?? 1),
            };
        });
    }

    let parts = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

    //create preOrder
    const createPreOrder = async (dataOrder, part, invoiceTotalDiscount, invoiceSubtotal, invoiceTotalItbms, invoiceTotal, taxesArray) => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'))
        let user = JSON.parse(localStorage.getItem('user'));

        let newOrderNumber = await getOrderNumber(true);
        console.log("newOrderNumber", newOrderNumber);
        let json = {
            "transaction_code": orderNumberNow,
            "client_name": dataOrder.client_name + " " + (countRef.current + 1),
            "localizador": dataOrder.locator,
            "client_phone": dataOrder.client_phone,
            "ruc": dataOrder.client_ruc,
            "dv": dataOrder.client_dv,
            "id_Client": 0,
            "dgi_qr": "0",
            "Orden": preserveKitchenStateForSplit(dataOrder.groups),
            "combos": preserveKitchenStateForSplit(dataOrder.combos),
            "Descuento": parseFloat(invoiceTotalDiscount),
            "discount": parseFloat(invoiceTotalDiscount),
            "Total": parseFloat(invoiceTotal),
            "itbms": parseFloat(invoiceTotalItbms),
            "taxes": taxesArray,
            "subtotal": parseFloat(invoiceSubtotal),
            "machine_id": machine.id,
            "branchoffice_id": branchoffice.id,
            "tipoOrden": dataOrder.order_type,
            "paymethod": 0,
            "is_discount_notification": false,
            "is_cupon": false,
            "is_devolution_notification": false,
            "justification": "Divide into parts - precuenta  original:" + dataOrder.transaction_code,
            "is_pre_order": true, "user": {
                id: user.id,
                name: user.name,
                code: user.user_code
            }
        }

        if (order.table_name) {
            json.table_name = order?.table_name || null
            json.table_id = order?.table_id || null
        }



        try {
            const response = await PreOrderFetchAPI.createPreOrder(json, token)
            if (response.data?.newTempOrder) {
                createdPreOrdersRef.current = [...createdPreOrdersRef.current, response.data.newTempOrder];
                createdOrderCodesRef.current = [...createdOrderCodesRef.current, response.data.newTempOrder.transaction_code || response.data.newTempOrder.code];
            }
            countRef.current = countRef.current + 1
            let message = "Precuenta creada con exito."
            let title = "Operacion exitosa."
            let icon = "success"

            console.log(part + "    " + countRef.current);
            if (part > countRef.current) {
                console.log(" entre: " + countRef.current);
                stringOrdersRferenceRef.current = createdOrderCodesRef.current.join(" / ")
                setOrdersCreated(createdOrderCodesRef.current.join(" / "))
                createPreOrder(dataOrder, part, invoiceTotalDiscount, invoiceSubtotal, invoiceTotalItbms, invoiceTotal)
            } else {
                countRef.current = 0
                setStateRequest(false)
                setShowParts(false);
                setShowDivision(false);

                deletePreOrder(dataOrder.code, dataOrder.transaction_code, createdOrderCodesRef.current.join(" / "));
                setEventHandler(1)
                resetInputs()

            }

        } catch (err) {
            setStateRequest(false)
            showApiError(err, {
                title: "No se pudo crear la precuenta dividida",
                message: "El servidor no pudo crear una de las partes de la precuenta.",
                context: `source_order=${dataOrder?.code || ""}`,
            }, ErrorAlert);
        }

    }

    //delete preorder
    const deletePreOrder = async (code, transaction_code, newOrderCode) => {
        LoadingAlert("Eliminando precuenta original", "Espere mientras se completa el borrado de la precuenta original...")
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))
        let user = JSON.parse(localStorage.getItem('user'));
        let machine_token = localStorage.getItem('x-access-machine-token');

        let business_code = business.code
        let branch_code = branchoffice.code

        if (codeParthner != 0) {
            business_code = codeParthner.business_code
            branch_code = codeParthner.branchoffice_code
        }

        let jsonUpdate = {
            "order_code": code,
            "business_code": business_code,
            "branchoffice_code": branch_code,
            "status": 5,
            "deleted": true,
            "justification": "Precuenta separada por partes iguales: codigo de precuenta original eliminada #" + transaction_code + ". Nuevas precuentas: #" + newOrderCode,
            "user_id": user.id,
            "deleted_code": "DIVIDED_BILL"
        }
        try {
            try {
                //We save the preorder deletion audit, but the real delete must not depend on it.
                await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, machine_token);
            } catch (auditErr) {
                console.log("No se pudo registrar la eliminacion de la precuenta dividida", auditErr);
            }

            //We delete the preorder
            await PreOrderFetchAPI.deletePreOrder(jsonUpdate, machine_token)
            let message = "precuenta eliminada con exito."
            let title = "Precuenta eliminada"
            let icon = "success"
            setOrdersCreated("")

            console.log("precuenta original eliminada");
            Swal.close();
            //ErrorAlert(message, title, icon)
            AlertSmall("Precuenta dividida con exito", "success")
            getAll();
        } catch (err) {
            if (isPendingDeleteTimeout(err)) {
                console.log("El borrado de la precuenta original sigue en proceso", err);
                Swal.close();
                onPendingDelete?.(code, createdPreOrdersRef.current);
                await ErrorAlert("El borrado de la precuenta original sigue en proceso. Las nuevas precuentas ya fueron creadas; refrescaremos la lista para verificar el estado.", "Borrado en proceso", "info", 10000);
                getAll();
                return;
            }

            showApiError(err, {
                title: "No se pudo eliminar la precuenta original",
                message: "Esta precuenta pertenece a otra sucursal o no se pudo eliminar.",
                context: `order_code=${code || ""} transaction=${transaction_code || ""}`,
                icon: "warning",
            }, ErrorAlert);
        }
    }

    const getPreOrderByid = async (state) => {
        let machine_token = localStorage.getItem('x-access-machine-token');
        try {
            const response = await PreOrderFetchAPI.getPreOrderById(order._id, machine_token);
            setDataOrder(response.data.pre_order)

            if (state == true) {
                setDataPreviewTotals({ discount: parseFloat(response.data.pre_order.discount), subtotal: parseFloat(response.data.pre_order.subtotal), tax: parseFloat(response.data.pre_order.tax), total: parseFloat(response.data.pre_order.total) });
            }
        } catch (err) {
            showApiError(err, {
                title: "No se pudo consultar la precuenta",
                message: "Error al consultar la precuenta para dividirla.",
                context: `pre_order_id=${order?._id || ""}`,
            }, ErrorAlert);
        }
    }



    const separateOrder = (part, state) => {
        stringOrdersRferenceRef.current = ""
        createdPreOrdersRef.current = [];
        createdOrderCodesRef.current = [];

        if (part != 0 && part != "") {
            dataOrder.groups.forEach(group => {
                divitionPartGroups(group)
            });

            dataOrder.combos.forEach(combo => {
                let priceGroup = (combo.price / part).toFixed(2);
                combo.price = parseFloat(priceGroup)
                let discount = (combo.discount / part).toFixed(2);
                let unit_discount = (combo.unit_discount / part).toFixed(2);

                console.log(combo.discount);
                console.log(discount);
                if (discount != NaN && discount != null && discount != undefined) {
                    combo.discount = parseFloat(discount)
                    combo.unit_discount = parseFloat(unit_discount)
                }

                combo.setGroups.forEach(setGroup => {
                    setGroup.groups.forEach((group => {
                        divitionPartGroups(group)
                    }))
                });

            });

            function divitionPartGroups(group) {
                let priceGroup = (group.price / part).toFixed(2);
                group.price = parseFloat(priceGroup)
                let discount = (group.discount / part).toFixed(2);
                let unit_discount = (group.unit_discount / part).toFixed(2);

                console.log(group.discount);
                console.log(discount);
                if (discount != NaN && discount != null && discount != undefined) {
                    group.discount = parseFloat(discount)
                    group.unit_discount = parseFloat(unit_discount)
                }

                group.segments.forEach(item => {
                    console.log("data del segmento");
                    console.log(item);
                    item.price = (item.item.price / part).toFixed(2);
                    item.item.price = (item.item.price / part).toFixed(2);
                });

                group.DetalleSegmentos = group.segments
            }



            calculateInvoiceTotals(dataOrder.groups, dataOrder.combos, state, part)
            console.log(dataOrder);

            /*
            let discount = 0;
            let subtotal = 0;
            let tax = 0;
            let total = 0;
 
            if (dataOrder.discount > 0) {
                discount = (dataOrder.discount / part).toFixed(2);
            }
 
            subtotal = (dataOrder.subtotal / part).toFixed(2);
            tax = (dataOrder.tax / part).toFixed(2);
            total = (dataOrder.total / part).toFixed(2);*/

        } else {

            setDataPreviewTotals({ discount: parseFloat(dataOrder.discount), subtotal: parseFloat(dataOrder.subtotal), tax: parseFloat(dataOrder.tax), total: parseFloat(dataOrder.total) });
        }
    }

    const calculateInvoiceTotals = (products, combos, state, part) => {

        //For every new calculate we set the totals
        let taxesArray = [];
        let invoiceTotalDiscount = 0
        let invoiceSubtotal = 0
        let invoiceTotalItbms = 0
        let invoiceTotal = 0

        //if we dont we products we put the totals in 0 for default
        if ((products.length + combos.length) > 0) {
            //For every product we calculate
            combos.forEach((combo) => {
                byProductandCombo(combo)
            })

            products.forEach((group) => {
                byProductandCombo(group)
            })

            function byProductandCombo(item) {
                let product_info = item
                //Variables
                let total_product_price = 0;
                let total_product_itbms = 0;
                let product_total_discount = 0;
                //We set the total discount of the product
                product_total_discount = (product_info.unit_discount * product_info.amount);
                //We set the total of the product
                total_product_price = (product_info.amount * (product_info.price - product_info.unit_discount));


                //Calculate tax by group--------------------------------
                let taxesGroup = product_info.taxes;
                taxesGroup.forEach(tax => {

                    //calculate tax  value and add it to array
                    let valueTax = (product_info.amount * ((product_info.price - product_info.unit_discount) * tax.taxtValue));
                    tax.total = valueTax;
                    //Identifier tax of the group position
                    var index = taxesArray.findIndex(function (info, i) {
                        return info.tax_id === tax.tax_id
                    });

                    if (index < 0) {
                        let taxInfoNow = {
                            "dTasaITBMSValue": tax.dTasaITBMSValue,
                            "percentage": tax.percentage,
                            "tax": tax.tax,
                            "tax_id": tax.tax_id,
                            "taxtValue": tax.taxtValue,
                            "total": valueTax
                        }
                        taxesArray.push(taxInfoNow);
                    } else {
                        taxesArray[index].total = (taxesArray[index].total + valueTax)
                    }
                    total_product_itbms = (total_product_itbms + valueTax);

                });
                //-------------------------------------------------------


                //We set the itbms of the product
                //total_product_itbms = (product_info.amount * ((product_info.price - product_info.unit_discount) * product_info.taxtValue));

                //We calculate the totals of the invoice
                invoiceTotalDiscount = invoiceTotalDiscount + product_total_discount;
                invoiceSubtotal = invoiceSubtotal + total_product_price;
                invoiceTotalItbms = invoiceTotalItbms + total_product_itbms;
                invoiceTotal = invoiceTotal + total_product_price + total_product_itbms;
            }

            console.log("Descuento:" + invoiceTotalDiscount);
            console.log("SubTotal:" + invoiceSubtotal);
            console.log("Itbms:" + invoiceTotalItbms);
            console.log("Total:" + invoiceTotal);


            console.log("Total de todas las partes:" + (invoiceTotal * part).toFixed(2));


            console.log({ discount: invoiceTotalDiscount, subtotal: invoiceSubtotal, tax: invoiceTotalItbms, total: invoiceTotal });
            setDataPreviewTotals({ discount: parseFloat(invoiceTotalDiscount), subtotal: parseFloat(invoiceSubtotal), tax: parseFloat(invoiceTotalItbms), total: parseFloat(invoiceTotal) });


            if (state == true) {

                setStateRequest(true)
                LoadingAlert("Dividiendo precuenta", "Espere mientras se crean las nuevas precuentas...")
                createPreOrder(dataOrder, part, invoiceTotalDiscount, invoiceSubtotal, invoiceTotalItbms, invoiceTotal, taxesArray)


            } else {
                setDivision(part);
                setEventHandler(1)
            }

        }


    }


    const keyBoardNumeric = (value) => {
        getPreOrderByid();
        setDivision(division + value)
        separateOrder(division + value);
    }


    useEffect(() => {
        (async () => {
            getPreOrderByid(true);


        })();
    }, [])

    useEffect(() => {
        setEventHandler(0);
    }, [eventHandler])


    return (
        <>
            {/* Botón disparador */}
            <button type="button" className="sp-divopt" onClick={() => setShowParts(true)}>
                <span className="sp-divopt__ic"><i className="uil uil-apps"></i></span>
                <span className="sp-divopt__label">Partes iguales</span>
            </button>

            <Modal
                show={showParts}
                fullscreen
                onHide={() => setShowParts(false)}
                aria-labelledby="example-custom-modal-styling-title"
                contentClassName="sp-divm-content"
                centered
            >
                <Modal.Body className="sp-divm border">

                    <div className="sp-divm__head">
                        {/* <div className="sp-divm__badge"><i className="uil uil-apps"></i></div> */}
                        <h4 className="sp-divm__title">Dividir en partes iguales</h4>
                        <button className="sp-divm__x" type="button" aria-label="Cerrar" onClick={() => setShowParts(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    <div className="sp-divm__body">
                        <div className="sp-diveq">

                            {/* Calculadora */}
                            <div className="sp-diveq__calc">
                                <h3 className="sp-diveq__calctitle"><i className="uil uil-calculator"></i> Calculadora de cuentas</h3>

                                <div className="sp-diveq__display">
                                    <span className="sp-diveq__display-label">Ingrese cantidad de cuentas a dividir</span>
                                    <span className="sp-diveq__display-val" translate="no">{division == "" ? "1" : division} / {order.total.toFixed(2)} = {dataPreviewTotals.total.toFixed(2)}</span>
                                </div>

                                <div className="sp-diveq__keys">
                                    {parts.map((index) => (
                                        <button type="button" className="sp-diveq__key" key={index} onClick={() => (keyBoardNumeric(index))}>{index}</button>
                                    ))}
                                    <button type="button" className="sp-diveq__key sp-diveq__key--clear" onClick={() => (getPreOrderByid(), setDivision(""), separateOrder(""))}>Limpiar</button>
                                </div>
                            </div>

                            {/* Detalle + totales por partes */}
                            <div className="sp-diveq__detailcol">
                                <ModalDetailPreOrder orderData={order}></ModalDetailPreOrder>

                                <div className="sp-diveq__totals">
                                    <h6 className="sp-diveq__totalstitle">Detalle de los totales en: {division} partes</h6>
                                    <div className="sp-diveq__trow">
                                        <span>Descuento</span>
                                        <span className="is-warning" translate="no">- $ <strong>{dataPreviewTotals.discount.toFixed(2)}</strong></span>
                                    </div>
                                    <div className="sp-diveq__trow">
                                        <span>Subtotal</span>
                                        <span translate="no">$ {dataPreviewTotals.subtotal.toFixed(2)}</span>
                                    </div>
                                    {order.taxes.map((tax, idx) => (
                                        <React.Fragment key={idx}>
                                            {tax.total.toFixed(3) > 0 ?
                                                <div className="sp-diveq__trow">
                                                    <span>Impuesto {tax.tax}</span>
                                                    <span translate="no">$ {tax.total.toFixed(3)}</span>
                                                </div> : <></>}
                                        </React.Fragment>
                                    ))}
                                    <div className="sp-diveq__trow sp-diveq__trow--total">
                                        <span>Total <small>(Incluye itbms)</small></span>
                                        <span translate="no">$ {dataPreviewTotals.total.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="sp-divm__foot">
                        <button className="sp-divm__btn sp-divm__btn--cancel" onClick={() => setShowParts(false)}>Cancelar</button>
                        <button className="sp-divm__btn sp-divm__btn--primary" onClick={() => separateOrder(division, true)} disabled={stateRequest}>Dividir</button>
                    </div>

                </Modal.Body>
            </Modal>


        </>
    )
}

export default ModalDivisionequalparts
